'use client';

import { CacheProvider } from '@chakra-ui/next-js';
import { ChakraProvider, extendTheme } from '@chakra-ui/react';
import React, { ReactNode } from 'react';

interface ThemeProviderProps {
  children: ReactNode;
  nonce?: string;
}

export const breakpoints = {
  sm: '480px',
  md: '768px',
  lg: '992px',
  xl: '1440px',
};

// Extend the theme to include custom colors, fonts, etc
export const chakraThemeWithNewBreakpoints = extendTheme({
  breakpoints,
});

export const ChakraThemeProvider = ({
  children,
  nonce,
}: ThemeProviderProps) => {
  return (
    <CacheProvider nonce={nonce}>
      <ChakraProvider theme={chakraThemeWithNewBreakpoints}>
        {children}
      </ChakraProvider>
    </CacheProvider>
  );
};
